export const INDIVIDUAL_DOCTOR_APPOINTMENT_API = "doctor/my-appointments-rev2";
export const INDIVIDUAL_STAFF_APPOINTMENT_API = "staff/my-appointments-rev2";
export const CLINIC_DOCTOR_APPOINTMENT_API = "clinic/my-appointments";
export const CLINIC_STAFF_APPOINTMENT_API = "clinic/my-appointments";

export const GET_ALL_APPOINTMENTS_API = "api/v1/doctor/appointments";
export const MARK_CHECK_IN_API = "doctor/appointment-check-in";
export const START_CONSULTATION_API = "doctor/start-consultation";
export const END_CONSULTATION_API = "doctor/complete-consultation";
export const GET_APPOINTMENT_JOURNEY_API = "doctor/get-appointment-journey";
export const CHECK_NO_SHOW_STATUS_API = "doctor/check-no-show-status";
export const CHECK_IN_PROGRESS_APPOINTMENT_API = "doctor/check-for-appointment";
export const CLOSE_MEETING_API = "/doctor/close-meeting";

export const GET_ALL_PROCEDURES_API = "doctor/get-all-procedures";
export const GET_CLINIC_PROCEDURES_API = "clinic/get-procedure";
export const GET_REFRESHED_DATA_API = "api/v1/doctor/appointments-refresh";

export const GET_STAFF_DOCTOR_LIST_API = "staff/get-complete-staff-info";
export const GET_CLINIC_DOCTOR_LIST_API = "clinic/get-clinic-doctors";
export const DOWNLOAD_TRANSACTIONS_REPORT_API = "api/v1/download-report";

export const GET_CHECKED_IN_APPOINTMENT_API = "api/v1/get-checked-in-status";
export const CALL_NEXT_APPOINTMENT_API = "api/v1/appointment/call-next-appt";
export const GET_TOTAL_BOOKED_APPOINTMENTS = "api/v1/doctor-total-appointments";
export const GET_UHID_LIST = (clinic_id) =>
  `/api/v1/${clinic_id}/check_patient_uhid`;
export const CREATE_CRON_SCHEDULE = "api/v1/create_cron_schedule";

export const APPOINTMENT_TYPE = {
  IN_CLINIC: "in-clinic",
  ONLINE: "online",
  INSTANT: "instant",
};

export const CONSULTATION_TYPE = [
  { id: 0, value: "Tele-Consult Regular" },
  { id: 1, value: "Tele-Consult Follow-Up" },
  { id: 2, value: "Instant Consultation" },
  { id: 4, value: "Procedure" },
  { id: 5, value: "In-Clinic Regular" },
  { id: 6, value: "In-Clinic Follow-Up" },
];

export const PAYMENT_METHOD = {
  CASH: "cash",
  ONLINE: "online",
};
